import CancelIcon from "@mui/icons-material/Cancel";

import Dropdown from "@musicfy/components/Dropdown";

export enum Gender {
  male = "male",
  female = "female",
}

interface IGenderFilterProps {
  genderFilter: Gender | null;
  setGenderFilter: React.Dispatch<React.SetStateAction<Gender | null>>;
}

const GenderFilter = ({
  genderFilter,
  setGenderFilter,
}: IGenderFilterProps): JSX.Element => {
  if (!!genderFilter) {
    return (
      <div
        onClick={() => setGenderFilter(null)}
        role="button"
        tabIndex={0}
        aria-label="Remove Gender Filter"
        className="py-3 px-4 transition-all flex items-center gap-2 cursor-pointer capitalize bg-gray-1000/30 backdrop-blur-xl border border-white/20 xl:hover:border-white/60 rounded-8"
      >
        <CancelIcon className="!text-18 !text-white/90" />
        <div className="text-14">{genderFilter}</div>
      </div>
    );
  }

  return (
    <Dropdown
      value={genderFilter}
      setValue={setGenderFilter}
      options={[
        { value: Gender.female, label: "Female" },
        { value: Gender.male, label: "Male" },
      ]}
      placeholder="Select Gender"
    />
  );
};

export default GenderFilter;
